module.exports = __webpack_public_path__ + "img/guifan5.71072378.png";